import React, { useState, useContext, useEffect } from "react";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { icons } from "../../../constants";
import AccreditationInput from "../../AccreditationInput/AccreditationInput";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { validateString } from "../../../utils/validateString";
import { trimValues } from "../../../utils/trimValues";
import { createPublicData } from "../../../utils/methods";
import { apiRoutes } from "../../../utils/apiRoutes";
import { useAlert } from "../../../utils/AlertContext";
import Loader from "../../Loader/Loader";

const RESEND_COOLDOWN_SECONDS = 60;

const ForgotPassword = ({ onCloseClick }) => {
  const { t } = useContext(TranslationsContext);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cooldownSeconds, setCooldownSeconds] = useState(0);
  const { showAlert } = useAlert();

  const setInputValue = (value) => {
    setEmail(value);
  };

  // Ticks the cooldown down once a second while it's running — re-enables
  // the button on its own once it hits 0, no separate timeout to track.
  useEffect(() => {
    if (cooldownSeconds <= 0) return;
    const timer = setTimeout(() => setCooldownSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldownSeconds]);

  const handleSendClick = async () => {
    if (cooldownSeconds > 0) return;

    setError();
    const err = validateString(email, "e_mail");
    setError(err);

    if (err) {
      return;
    }

    setIsLoading(true);
    const sendData = trimValues({ username: email });
    const forgot = true;

    try {
      const result = await createPublicData(
        apiRoutes.forgottenPassword,
        sendData,
        showAlert,
        t,
        forgot,
      );

      if (!result) return;

      console.log("Podaci su uspešno sačuvani:", result.data);
      showAlert(
        t(
          "IF_THE_ACCOUNT_EXISTS_PASSWORD_RESET_INSTRUCTIONS_HAVE_BEEN_SENT_TO_YOUR_EMAIL",
        ),
        "success",
      );
      // Stay on this modal — the reset link in the email is the only way
      // into the next step, not a redirect from here — and lock the button
      // for a minute so a re-click can't fire off a burst of reset emails.
      setCooldownSeconds(RESEND_COOLDOWN_SECONDS);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Handle Enter key to trigger primary action
    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" && target.type !== "submit")
        ) {
          return;
        }
        event.preventDefault();
        handleSendClick();
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [email]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex-direction-column gap-24 justify-between forgot-password-modal">
      <div className="flex-direction-column gap-24 width-100 modal-content">
        {" "}
        <div className="flex-direction-row justify-between pointer width-100">
          <p className="inria-sans-400 font-24 modal-title">
            {t("UI_FORGOTTEN_PASSWORD")}
          </p>
          <img
            className="pointer"
            src={icons.close_gray}
            onClick={onCloseClick}
            alt="X"
          />
        </div>
        <p className="inria-sans-400 font-14 forgot-password-description">
          {t("UI_ENTER_EMAIL_WE_WILL_SENT_LINK")}
        </p>
        <AccreditationInput
          className="modal-input"
          label={t("EMAIL")}
          setInputValue={(value) => setInputValue(value)}
          value={email}
          error={error}
          required={true}
        />
        <AccreditationButton
          type="save"
          title={
            cooldownSeconds > 0
              ? `${t("SEND")} (${cooldownSeconds}s)`
              : t("SEND")
          }
          onClick={handleSendClick}
          className="login-btn"
          disabled={cooldownSeconds > 0}
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
